import moment from 'moment'

export default {
  format(time, format) {
    return moment(time).locale('ru').add(3, 'hours').format(format)
  }
}